import { ANALYTIC_SET_LIST, ANALYTIC_SAVE } from './actionTypes';

const defaultState = {
  analyticList: [],
};

export function analytic(state = defaultState, action) {
  const { type, payload } = action;

  switch (type) {
    case ANALYTIC_SET_LIST: {
      return { ...state, analyticList: payload };
    }
    default:
      return state;
  }
}
